module.exports = __webpack_public_path__ + "static/media/Teko-Bold.8ec04ac8.ttf";